import { useContext } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { ClientContext } from '../../../contextApi/ClientContext';

export default function PaymentTable() {
    const { currentWebsite, setToastMessage, messagesOptions, accent_color, secondary_color, primary_color } = useContext(AppContext);
    const { deployCartArr } = useContext(ClientContext);
    return (
        <table className='payment_table' style={{ border:`1px solid ${accent_color}`, backgroundColor:primary_color}}>
            <thead>
                <tr className='payment_tr'>
                    <th dir='rtl' className='payment_th' style={{border:`1px solid ${accent_color}` ,color:accent_color}}>מחיר ליחידה</th>
                    <th dir='rtl' className='payment_th' style={{border:`1px solid ${accent_color}` ,color:accent_color}}>כמות</th>
                    <th dir='rtl' className='payment_th' style={{border:`1px solid ${accent_color}` ,color:accent_color}}>שם המוצר</th>
                </tr>
            </thead>
            <tbody>
                {deployCartArr(currentWebsite, setToastMessage, messagesOptions, accent_color)}
            </tbody>
        </table>
    )
}
